exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer.footer[data-v-34868a2b]{position:absolute;bottom:0;width:100%;height:180px;background-color:#f5f5f5}footer.footer p[data-v-34868a2b]{font-size:.85rem;margin:0}footer.footer .container[data-v-34868a2b]{position:absolute;top:60%;left:0;right:0;transform:translateY(-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34868a2b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/StephFooter.vue
// module id = 267
// module chunks = 0